/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { Currency } from '@app/settings/currencies/currency.model';
import { BankaccountableType } from '@app/banks/bankaccountable-type.enum';

export class BankAccount extends Model {
  id: number;
  name: string;
  iban: string;
  bic: string;

  abbreviation: string;
  beneficiary_name: string;
  address: string;
  currency_id: number;
  currency?: Currency;

  sort_code: string;
  account_number: string;

  bankaccountable_type: BankaccountableType;
  bankaccountable_id: number;

  balance: number;
  current_balance: number;
  last_balance: number;
  payment_calculation_date: string;

  get displayName(): string {
    let str = '';
    if (this.abbreviation) {
      str += this.abbreviation + '/';
    }
    if (this.name) {
      str += this.name + '/';
    }
    if (this.currency && this.currency.code) {
      str += this.currency.code;
    }
    return str;
  }
}
